/**
 * @name scrollToElement
 * @description Force the browser window to scroll to an element on the page
 *
 * ! Not optimised for lazyloaded images
 */
export const scrollToElement = (
  el: HTMLElement,
  position: 'top' | 'middle' | 'bottom',
  behavior: ScrollBehavior = 'smooth'
): void => {
  if (!el) {
    return;
  }

  let scrollToPosition: number;

  const elementRect = el.getBoundingClientRect();
  const elPosition = elementRect.top + window.pageYOffset;

  switch (position) {
    default:
    case 'top':
      scrollToPosition = elPosition - window.innerHeight / 2;
      break;

    case 'middle':
      scrollToPosition =
        elPosition - (window.innerHeight - elementRect.height) / 2;
      break;

    case 'bottom':
      scrollToPosition =
        elPosition + (window.innerHeight - elementRect.height) / 2;
      break;
  }

  window.scrollTo({
    top: scrollToPosition,
    left: 0,
    behavior,
  });
};
